// MIME negotiation for MediaRecorder.
// iOS Safari (≤17) ignores the MIME option and emits `audio/mp4` regardless.
// Android Chrome + desktop prefer `audio/webm;codecs=opus` (better compression).
// BE transcodes mp4 → aac before Gemini; we just record whatever the device likes.

export const PREFERRED_MIMES = [
  'audio/webm;codecs=opus',
  'audio/webm',
  'audio/ogg;codecs=opus',
  'audio/mp4',
] as const;

export function pickRecorderMime(): string | undefined {
  if (typeof MediaRecorder === 'undefined') return undefined;
  for (const m of PREFERRED_MIMES) {
    if (MediaRecorder.isTypeSupported(m)) return m;
  }
  return undefined; // fall back to browser default (iOS)
}

export function isIosLike(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;
  return /iPad|iPhone|iPod/.test(ua) || (ua.includes('Mac') && 'ontouchend' in document);
}
